var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_vm._v(" 来错地方了? "),_c('br'),_vm._v(" 404 NOT FOUND ")])}]

export { render, staticRenderFns }